/*
  card-recomendado.js
  Lógica compartida de las cards ".reco-card" usadas en:
    - la sección "Recomendados (carrusel)" de la PDP (sections/recomendados-carrusel.liquid)
    - la grid de colección (sections/main-collection-template.liquid)

  Las funciones son globales (window.reco*) porque en el carrusel las cards se
  inyectan con innerHTML: los <script> internos no corren, pero los onclick= sí
  resuelven contra window. En la grid de colección las cards se renderizan del
  lado servidor, así que estos globales quedan disponibles igual.

  El custom element <reco-carousel> (lazy-load + Swiper) NO vive aquí: es propio
  del carrusel y permanece inline en su sección.
*/
(function () {
  if (typeof window.recoSelectOption !== 'function') {
    window.recoMoney = function (cents) {
      var out;
      if (window.theme && theme.Currency && theme.Currency.formatMoney) {
        out = theme.Currency.formatMoney(cents, (window.theme && theme.moneyFormat) || '${{amount}}');
      } else {
        out = '$' + (cents / 100).toFixed(2);
      }
      return out.replace('MXN', '').trim();
    };

    // Previsualiza el nombre del color al pasar el cursor.
    window.recoPreviewColor = function (el) {
      var card = el.closest('.reco-card');
      var cap = card && card.querySelector('.reco-swatch-current');
      if (cap) cap.textContent = el.getAttribute('data-value') || '';
    };
    // Restaura el nombre del color activo al salir.
    window.recoResetColor = function (el) {
      var card = el.closest('.reco-card');
      if (!card) return;
      var active = card.querySelector('.reco-swatch.is-active');
      var cap = card.querySelector('.reco-swatch-current');
      if (cap && active) cap.textContent = active.getAttribute('data-value') || '';
    };

    window.recoSelectOption = function (el, type) {
      if (el.classList.contains('is-soldout')) return;
      var card = el.closest('.reco-card');
      if (!card) return;

      var listSelector = type === 'color' ? '.reco-swatch' : '.reco-size';
      card.querySelectorAll(listSelector).forEach(function (i) { i.classList.remove('is-active'); });
      el.classList.add('is-active');

      if (type === 'color') {
        var newSrc = el.getAttribute('data-hover-image');
        var img = card.querySelector('.reco-card__img');
        if (newSrc && img) {
          img.src = newSrc;
          img.removeAttribute('srcset');
        }
        var cap = card.querySelector('.reco-swatch-current');
        if (cap) cap.textContent = el.getAttribute('data-value') || '';
      }

      var jsonEl = card.querySelector('.reco-variants-json');
      if (!jsonEl) return;
      var variants = [];
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      var colorPos = card.getAttribute('data-color-pos');
      var sizePos = card.getAttribute('data-size-pos');
      var activeColor = card.querySelector('.reco-swatch.is-active');
      var activeSize = card.querySelector('.reco-size.is-active');
      var colorVal = activeColor ? activeColor.getAttribute('data-value') : null;
      var sizeVal = activeSize ? activeSize.getAttribute('data-value') : null;

      var found = variants.find(function (v) {
        if (colorPos && colorVal && String(v[colorPos]) !== colorVal) return false;
        if (sizePos && sizeVal && String(v[sizePos]) !== sizeVal) return false;
        return true;
      });

      var addBtn = card.querySelector('.js-reco-add');
      var priceEl = card.querySelector('.reco-card__price');
      var wasEl = card.querySelector('.reco-card__was');
      var badgeEl = card.querySelector('.reco-card__sale-badge');

      if (found) {
        if (addBtn) {
          addBtn.setAttribute('data-variant-id', found.id);
          addBtn.disabled = !found.available;
          addBtn.textContent = found.available ? 'Agregar' : 'Agotado';
        }
        if (priceEl) priceEl.textContent = window.recoMoney(found.price);
        if (wasEl) {
          if (found.compare_at_price && found.compare_at_price > found.price) {
            wasEl.innerHTML = 'Antes <s>' + window.recoMoney(found.compare_at_price) + '</s>';
          } else {
            wasEl.textContent = '';
          }
        }
        if (badgeEl) {
          if (found.compare_at_price && found.compare_at_price > found.price) {
            var discountPct = Math.round(((found.compare_at_price - found.price) / found.compare_at_price) * 100);
            badgeEl.textContent = '-' + discountPct + '%';
            badgeEl.style.display = discountPct > 0 ? '' : 'none';
          } else {
            badgeEl.style.display = 'none';
          }
        }
      } else if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'No disponible';
      }
    };
  }

  // Quick-add: delegación en document para cards renderizadas server-side
  // (colección) o inyectadas async (carrusel). Guard para no doblar el listener.
  if (!window.__recoAddBound) {
    window.__recoAddBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-reco-add');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id || btn.disabled) return;
      var original = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '…';
      window.jQuery.post({
        url: '/cart/add.js',
        data: { quantity: 1, id: id },
        dataType: 'json'
      }).done(function () {
        if (window.theme && theme.miniCart) {
          theme.miniCart.updateElements();
          theme.miniCart.generateCart();
        }
      }).fail(function (xhr) {
        var d = xhr.responseJSON;
        if (window.theme && theme.alert) {
          theme.alert.new('', (d && d.description) || 'Error', 3000, 'warning');
        }
      }).always(function () {
        btn.disabled = false;
        btn.innerHTML = original;
      });
    });
  }
})();